import store from '../apps/store/store'
import { setCart, setCartOpen } from '../apps/store/cartSlice'

export const getCart = (callback = null, open = true, buttonElement = null) => {
  fetch(window.Shopify.routes.root + 'cart.js', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then((response) => {
      return response.json()
    })
    .then((cart) => {
      console.log(cart)
      store.dispatch(setCart(cart))
      store.dispatch(setCartOpen(open))
      if (buttonElement) buttonElement.disabled = false
      if (callback) callback(cart)
    })
    .catch((error) => {
      console.error('Error:', error)
    })
}

window.getCart = getCart

export const addLineItem = (callback = null, body = null, open = true, buttonElement = null) => {
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    body: body,
  })
    .then((response) => {
      console.log(response)
      getCart(callback, open, buttonElement)
    })
    .catch((error) => {
      console.error('Error:', error)
    })
}
window.addLineItem = addLineItem

export const changeLineItem = (callback = null, item = {}, open = true) => {
  fetch(window.Shopify.routes.root + 'cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(item),
  })
    .then((response) => {
      return response.json()
    })
    .then((cart) => {
      console.log(cart)
      store.dispatch(setCart(cart))
      store.dispatch(setCartOpen(open))
      if (callback) callback(cart)
    })
    .catch((error) => {
      console.error('Error:', error)
    })
}

export const updateCart = (callback = null, attributes = {}, open = true) => {
  fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ attributes }),
  })
    .then((res) => res.json())
    .then((cart) => {
      console.log(cart)
      store.dispatch(setCart(cart))
      store.dispatch(setCartOpen(open))
      if (callback) callback(cart)
    })
    .catch((error) => {
      console.error('Error:', error)
    })
}
